// extracted by mini-css-extract-plugin
export default {"movies-list":"MoviesList_movies-list__xnKYG","movie-item-link":"MoviesList_movie-item-link__kZob0"};